export const MAP_ZOOM_AREA_LEVEL = 18;
